import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  span {
    margin-bottom: 3rem;
    color: ${(props) => props.theme.color.neutral.gray};
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;

  #minutes {
    margin-top: 2.5rem;
    color: ${(props) => props.theme.color.neutral.gray};
    font-size: 14px;
    font-weight: 500;
  }
  #warn {
    margin-top: 2.5rem;
    font-size: 12px;
    font-weight: 500;
  }
`

export const InputContainer = styled.div<{ width?: string }>`
  display: flex;
  height: 100%;
  gap: 0.3rem;
  flex-direction: column;
  width: ${(props) => (props.width ? props.width : '100%')};
`
